import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash'

import { certificatesReselector as stateSelector } from 'reduxModules/certificates/selectors'
import { certificatesDispatchers as dispatchSelector } from 'reduxModules/certificates/dispatchers'

import './styles.css'

// Completion callout for the course detail page. A certificate exists in the
// user's list only for courses they've finished, so its presence (matched by
// slug) is our "course completed" signal — claimed certs carry a downloadUrl,
// unclaimed ones deep-link to the claim modal on the My Certificates page.
export function CertificateBanner({
  slug,
  isAuth = false,
  certificates = null,
  ...props
}) {
  useEffect(() => {
    // User-scoped data: only fetch when logged in, and only once (the list is
    // shared redux state that the My Certificates page may already have filled).
    if (isAuth && certificates === null) props.loadCertificates()
  }, [isAuth])

  if (!isAuth || !certificates) return null

  const certificate = _.find(certificates, (c) => c.tutorial.slug === slug)
  if (!certificate) return null

  const { isClaimed, downloadUrl } = certificate

  return (
    <div className="wrapper">
      <aside className="certificate-banner">
        <span className="certificate-banner__seal" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="30" height="30">
            <path
              fill="currentColor"
              d="M12 2a5 5 0 0 0-3 9l-2 9 5-2.6L17 20l-2-9a5 5 0 0 0-3-9Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
            />
          </svg>
        </span>

        <div className="certificate-banner__text">
          <span className="certificate-banner__eyebrow">
            Certificate of Completion
          </span>
          <p className="certificate-banner__title">You completed this course!</p>
          <p className="certificate-banner__subtitle">
            {isClaimed
              ? 'Your Certificate of Completion is ready to download.'
              : 'Redeem your certificate to celebrate your achievement.'}
          </p>
        </div>

        <div className="certificate-banner__actions">
          {isClaimed ? (
            <>
              <a
                href={downloadUrl}
                target="_blank"
                rel="noreferrer"
                className="btn -thin -orange certificate-banner__cta"
              >
                Download Certificate
              </a>
              <Link to="/certificates" className="certificate-banner__manage">
                View in My Certificates
              </Link>
            </>
          ) : (
            <Link
              to={`/certificates?course=${slug}`}
              className="btn -thin -orange certificate-banner__cta"
            >
              Get Your Certificate
            </Link>
          )}
        </div>
      </aside>
    </div>
  )
}

CertificateBanner.propTypes = {
  slug: PropTypes.string.isRequired,
  isAuth: PropTypes.bool,
  certificates: PropTypes.arrayOf(PropTypes.object),
  loadCertificates: PropTypes.func.isRequired
}

export default connect(stateSelector, dispatchSelector)(CertificateBanner)
